/**
 * Cadre x Appstle UI Enhancer (FULL FILE)
 * - Runs ONLY on product id: 9427549946097
 * - Adds "Most Popular" pill + benefits list to Subscription option
 * - Fixes selected-state styling by toggling .cadre-selected based on checked radio
 * - Makes the ENTIRE option card clickable (including injected benefits area)
 * - Safe with Appstle re-renders (MutationObserver)
 */

(function () {
  const TARGET_PRODUCT_ID = "9427549946097";

  // ---- Helpers ----
  function getCurrentProductId() {
    // Try common Shopify theme sources (varies by theme)
    const el =
      document.querySelector('[name="product-id"]') ||
      document.querySelector("[data-product-id]") ||
      document.querySelector('form[action^="/cart/add"] [name="id"]');

    // Some themes expose product id in JS objects
    const fromWindow =
      window?.meta?.product?.id ||
      window?.ShopifyAnalytics?.meta?.product?.id ||
      window?.Shopify?.product?.id;

    const fromDom =
      (el && el.value) ||
      (el && el.dataset && el.dataset.productId) ||
      null;

    return String(fromDom || fromWindow || "");
  }

  function isTargetProduct() {
    return getCurrentProductId() === TARGET_PRODUCT_ID;
  }

  function findWidget() {
    // If your widget id changes, swap this to:
    // return document.querySelector('[id^="appstle_subscription_widget"]');
    return document.querySelector("#appstle_subscription_widget0");
  }

  /**
   * Bulletproof selected-state sync:
   * whichever option contains a checked radio gets .cadre-selected
   */
  function syncCadreSelectedState(widget) {
    const options = Array.from(
      widget.querySelectorAll(".appstle_subscription_wrapper_option")
    );

    options.forEach((opt) => {
      const checked = opt.querySelector('input[type="radio"]:checked');
      opt.classList.toggle("cadre-selected", Boolean(checked));
    });
  }

  /**
   * Make the entire option card clickable.
   * Clicking anywhere (including injected benefits) selects that option's radio.
   */
  function makeOptionsFullyClickable(widget) {
    const options = Array.from(
      widget.querySelectorAll(".appstle_subscription_wrapper_option")
    );

    options.forEach((opt) => {
      // Bind once per option element
      if (opt.dataset.cadreClickBound) return;
      opt.dataset.cadreClickBound = "1";

      opt.style.cursor = "pointer";

      opt.addEventListener("click", (e) => {
        // If user clicked a native interactive control, do not interfere
        const interactive = e.target.closest(
          "a, button, input, select, textarea, label"
        );
        if (interactive) return;

        const radio = opt.querySelector('input[type="radio"]');
        if (!radio) return;

        // If already checked, do nothing
        if (radio.checked) return;

        // Trigger Appstle's normal handlers
        radio.click();
      });
    });
  }

  /**
   * Inject subscription-specific UI:
   * - pill
   * - benefits list
   */
  function injectSubscriptionExtras(widget) {
    const options = Array.from(
      widget.querySelectorAll(".appstle_subscription_wrapper_option")
    );
    if (!options.length) return;

    // Find the subscription option by text match (robust across Appstle widget types)
    const subOption = options.find((el) => /subscribe/i.test(el.textContent));
    if (!subOption) return;

    // Add pill once
    if (!subOption.querySelector(".cadre-pill")) {
      const labelTarget =
        subOption.querySelector(
          ".appstle_option_label, .appstle_selling_plan_name"
        ) || subOption;

      const pill = document.createElement("span");
      pill.className = "cadre-pill";
      // ✅ TEXT CHANGE ONLY
      pill.textContent = "FIRST MONTH FREE - Launch Offer";
      labelTarget.appendChild(pill);
    }

    // Add benefits once
    if (!subOption.querySelector(".cadre-benefits")) {
      const ul = document.createElement("ul");
      ul.className = "cadre-benefits";
      // ✅ TEXT CHANGE ONLY
      ul.innerHTML = `
        <li>$0 today - just pay shipping</li>
        <li>Then $39/month (25% off for life)</li>
        <li>Cancel or pause anytime</li>
      `;
      subOption.appendChild(ul);
    }
  }

  // ---- Main enhancer ----
  function enhanceAppstle() {
    // Hard stop unless this is the exact product
    if (!isTargetProduct()) return;

    const widget = findWidget();
    if (!widget) return;

    // ✅ Make the entire card clickable (including injected content)
    makeOptionsFullyClickable(widget);

    // ✅ Keep selected card styling accurate (for BOTH options)
    syncCadreSelectedState(widget);

    // Bind change listener once so toggling updates instantly
    if (!widget.dataset.cadreBound) {
      widget.dataset.cadreBound = "1";
      widget.addEventListener("change", () => syncCadreSelectedState(widget));
      widget.addEventListener("click", () => syncCadreSelectedState(widget));
    }

    // ✅ Inject pill + benefits under subscription option
    injectSubscriptionExtras(widget);
  }

  // Run on initial load
  document.addEventListener("DOMContentLoaded", enhanceAppstle);

  // Appstle frequently re-renders; observe the DOM and re-apply enhancements
  const obs = new MutationObserver(() => {
    // Lightweight guard: only do work on the target product
    if (!isTargetProduct()) return;
    enhanceAppstle();
  });

  obs.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
